import React from 'react';
import { Link } from 'react-router-dom';
import {
    BENEFITS,
    PROFESSIONS,
    SALARY_DISCLAIMER,
    SALARY_FROM,
    SALARY_TO,
    WORK_REGIONS
} from '../data/siteData';
import { useFormModal } from '../context/FormModalContext';

const heroImage = '/images/guard-hero.png';

const HomePage = () => {
    const { openForm } = useFormModal();

    return (
        <>
            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <div className="hero-left">
                            <h1 className="hero-title">
                                <span className="hero-brand">Работа в охране вахтой</span>
                                <span className="hero-salary">
                                    ЗП от {SALARY_FROM.toLocaleString('ru-RU')} до{' '}
                                    {SALARY_TO.toLocaleString('ru-RU')} руб. в месяц
                                </span>
                            </h1>
                            <p className="hero-lead">Охрана объектов и сопровождение грузов</p>
                            <p className="hero-lead-sub">Официальное оформление</p>
                            <p className="hero-disclaimer">{SALARY_DISCLAIMER}</p>

                            <button type="button" className="cta-button" onClick={openForm}>
                                Подать заявку
                            </button>
                        </div>
                        <div className="hero-right">
                            <img src={heroImage} alt="Работа в охране вахтой" className="hero-image" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="location">
                <div className="container">
                    <h2 className="location-heading">Работа в регионах:</h2>
                    <ul className="location-regions-list">
                        {WORK_REGIONS.map((region) => (
                            <li key={region}>{region}</li>
                        ))}
                    </ul>
                    <p className="location-note">ПРОЕЗД К МЕСТУ РАБОТЫ ОПЛАЧИВАЕТ КОМПАНИЯ</p>
                    <p className="location-bonus-note">
                        ВЫПЛАЧИВАЮТСЯ ПОДЪЁМНЫЕ ПРИ ТРУДОУСТРОЙСТВЕ
                    </p>
                    <p className="location-bonus-note location-bonus-note-muted">
                        Условия уточняются индивидуально
                    </p>
                </div>
            </section>

            <section className="professions-section">
                <div className="container">
                    <h2 className="section-title">Вакансии охраны</h2>
                    <p className="section-lead">
                        <Link to="/vacancies">Подробное описание всех вакансий →</Link>
                    </p>
                    <div className="professions-grid">
                        {PROFESSIONS.map(({ title, description, details, image }) => (
                            <article key={title} className="profession-card">
                                {image && (
                                    <div className="profession-card-image-wrap">
                                        <img src={image} alt={title} className="profession-card-image" />
                                    </div>
                                )}
                                <div className="profession-card-body">
                                    <h3 className="profession-card-title">{title}</h3>
                                    <p className="profession-card-desc">{description}</p>
                                    <ul className="profession-card-details">
                                        {details.map((item) => (
                                            <li key={item}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className="benefits">
                <div className="container">
                    <h2 className="section-title">Преимущества компании</h2>
                    <p className="section-lead">
                        Условия для комфортной работы и уверенности в завтрашнем дне.
                    </p>
                    <div className="benefits-grid">
                        {BENEFITS.map(({ image, alt, title, description }) => (
                            <div key={title} className="benefit-card benefit-card-image">
                                <img src={image} alt={alt} />
                                <div className="benefit-overlay">
                                    <h3>{title}</h3>
                                    <p>{description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="cta-section">
                <div className="container">
                    <h2 className="cta-title">Готовы присоединиться?</h2>
                    <p className="cta-lead">
                        Оставьте заявку — перезвоним, расскажем условия по выбранной вакансии охраны и ответим на вопросы.
                    </p>
                    <button type="button" className="cta-button-large" onClick={openForm}>
                        ПОДАТЬ ЗАЯВКУ
                    </button>
                </div>
            </section>
        </>
    );
};

export default HomePage;
